import React, { useCallback, useContext, useEffect, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'
import moment from 'moment'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import { useChatContext } from 'stream-chat-react'
import { getOrCreatePortalChannel, getWeeklySummaryData2 } from '../../../../api'
import { getFirstName } from '../inspect/util'
import config from '../../../../config'
import { AuthContext } from '../../../../auth-context'
import { DashboardContext } from '../../dashboard-context'
import { ReactComponent as ArrowUp } from '../../../../images/arrow-up.svg'
import { ReactComponent as ArrowDown } from '../../../../images/arrow-down.svg'
import { Toggle } from '../overview/components/toggle'
import { Row, Action } from '../../../../components/action-button'
import Button from '../../../../components/button'
import { ErrorMessage } from '../../../../components/error-message'
import Input from '../../../../components/input'
import Modal from '../../../../components/modal'
import CircularProgress from '@material-ui/core/CircularProgress'
import Icon from '@material-ui/core/Icon'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles'
import ChatIcon from '@material-ui/icons/Chat'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import SearchIcon from '@material-ui/icons/Search'

const GridContainer = styled.div`
  padding: 32px 16px 200px 16px;
  margin: 0 auto;
  max-width: 1600px;
`;

const WeeklySelect = styled(Select)`
  padding: 7px 12px;
  width: 500px;
  border-radius: 100px;
  background-color: #eaedf5;
  color: #5a5a5a !important;
  font-family: 'DM Sans', sans-serif !important;
  font-size: 16px !important;
  font-weight: 300 !important;
  &.Mui-focused .MuiSelect-select {
    background-color: #eaedf5;
  }
  &:before {
    border: none !important;
  }
  &:after {
    border: none !important;
  }
`

const UpperWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 32px 16px;
  margin: 0 auto;
  max-width: 1600px;
  @media(max-width: 1200px) {
    flex-direction: column;
  }

  @media(max-width: 900px) {
    padding: 16px 8px;
  }
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: ${props => props.theme.font.primary};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }

  @media(max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const SummaryContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 540px;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const SummaryTable = styled.table`
  background: #FFF;
  border-spacing: 0px 10px;
  width: 100%;
`

const CustomDarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#08091f',
    color: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    fontFamily: 'DM Sans',
    fontSize: 12,
  },
  arrow: {
    color: '#08091f'
  }
}))(Tooltip)

const DarkTooltip = ({children, title, placement}) => (
  <CustomDarkTooltip
    arrow
    enterDelay={1300}
    title={title}
    placement={placement}
  >
    {children}
  </CustomDarkTooltip>
)

const TipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  p {
    font-size: .9rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  li {
    font-size: .9rem;
    font-weight: normal;
    margin-bottom: 4px;
    span {
      font-weight: bold;
    }
  }
  span {
    font-size: .9rem;
    font-weight: normal;
    text-align: center;
    margin-bottom: 4px;
  }
`

const ArrowsGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const TableContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 700px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`

const TableTitle = styled.h2`
  padding: 32px 0 16px 0;
  margin: 0 auto;
  color: #555;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`

const Table = styled.table`
  background: #FFF;
  border-spacing: 0px;
  width: 100%;
`

const TableHead = styled.thead`
  color: #FFF;
`

const TableBody = styled.tbody`
`

const TableHeadRow = styled.tr`
`

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${props => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${props => (props.bigWidth) ? '160px' : '100px' };
  padding: 8px;
  position: sticky;
  top: 0;
  z-index: 30;
`

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${props => props.number ? props.theme.font.primary : props.theme.font.secondary};
  padding: 4px;
  text-align: center;
`

const BulkMessageContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 540px;
  padding: 24px;
  margin-left: 32px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const ClearButton = styled(Button)`
  background: none;
  box-shadow: none;
  color: #888;
  margin: 0;

  &:hover {
    background: #EFEFEF;
  }

  &:active {
    background: #DDD;
    box-shadow: none;
    color: #555;
  }
`

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
`

const VacationText = styled.span`
  background: #06010d;
  border-radius: 30px;
  display: block;
  padding: 0px 4px;
  font-size: 0.7rem;
  font-weight: 600;
  width: 80px;
  margin: 0 auto;
  text-align: center;
  color: ${props => props.color || "#32F6DB"};
`;

const Weekly = (props) => {
  const theme = useContext(ThemeContext)
  const { user, updateUser } = useContext(AuthContext)
  const { client, setActiveChannel } = useChatContext()
  const { openSnackbar, filterGroupID, setFilterGroupID, clientsTrainerID, setClientsTrainerID, setShowMessages, setMessageChannel } = useContext(DashboardContext)
  const [createdStreamUsers, setCreatedStreamUsers] = useState([])
  const [all, updateAll] = useState(null)
  const [interval, updateInterval] = useState(0)
  const [selected, updateSelected] = useState(0)
  const [weeklySummaryDataState, updateWeeklySummaryDataState] = useState(0)
  const [weeklySummaryData, updateWeeklySummaryData] = useState(null)
  const [loading, updateLoading] = useState(false)
  const [bulkMessage, updateBulkMessage] = useState('')
  const [error, updateError] = useState('')
  const [result, updateResult] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [sortType, setSortType] = useState({type: 'name', reverse: false})

  const active_row_style = { cursor: 'pointer', backgroundColor: '#1fc44a' }
  const inactive_row_style = { cursor: 'pointer' }

  const headings_by_index = [
    'Covered Clients',
    'Viewable Clients',
    'Clients on ' + theme.goal['FAT LOSS'],
    'Clients on ' + theme.goal['MUSCLE GAIN'],
    'Clients on ' + theme.goal['REVERSE DIETING'],
    'Clients on ' + theme.goal['MAINTENANCE'],
    'Clients in Pause Your Goal Mode',
    'Clients in Practice Mode',
    'High Risk Clients',
    'Clients Who Missed Check-In',
    'Clients Who Missed Tracking',
    'Clients Who Missed Both',
    'Clients Who Checked In'
  ]

  const fetchWeeklySummaryData = useCallback((newAll, newInterval) => {
    updateWeeklySummaryDataState(1)
    return getWeeklySummaryData2(user.id, newAll, newInterval).then((res) => {
      updateWeeklySummaryData(res.data.accounts)
      updateWeeklySummaryDataState(2)
    })
  }, [user.id])

  useEffect(() => {
    if (weeklySummaryDataState === 0 && user.id) {
      let newAll = all
      if (newAll === null) {
        if (user.role_id === 1 || user.role_id === 2) {
          newAll = 1
        } else {
          newAll = 0
        }
        updateAll(newAll)
      }
      fetchWeeklySummaryData(newAll, interval)
    }
  }, [all, interval, weeklySummaryDataState, user.id, user.role_id, fetchWeeklySummaryData])

  useEffect(() => {
    if (weeklySummaryDataState === 2 && !!user.messaging) {
      let userStreamIds = []
      weeklySummaryData.forEach((row) => {
        if (row.user_id !== null && row.trainer_permission) {
          userStreamIds.push(config.STREAMCHAT.userPrefix + row.user_id.toString())
        }
      })
      userStreamIds = _.chunk(userStreamIds, 100)
      let streamUsersCreated = []

      const fetchData = async () => {
        await Promise.all(
          userStreamIds.map(async (streamIds) => {
            return await client.queryUsers(
              { id: { $in: streamIds } },
              { last_active: -1 },
              { presence: false, limit: 100 }
            );
          })
        ).then((response) => {
          response.forEach((res) => {
            if (res.users.length > 0) {
              res.users.forEach((data) => {
                streamUsersCreated.push(data.id)
              })
            }
          })
        })

        setCreatedStreamUsers(streamUsersCreated)
      }

      fetchData()
    }
  }, [weeklySummaryDataState, user.messaging, weeklySummaryData, client])

  const handleMessage = async (user_id) => {
    const getId = await getOrCreatePortalChannel(user.id, user_id)
    const channelId = getId?.data?.result?.channel_id

    if (channelId) {
      const filter = { id: channelId }
      const sort = { last_message_at: -1 }
      const options = { watch: true, state: true }
      const getChannel = await client.queryChannels(filter, sort, options)
      setActiveChannel(getChannel[0])
      setShowMessages(true)
      setMessageChannel(getChannel[0])
    }
  }

  const renderAtRisk = (at_risk) => {
    let result

    switch (at_risk) {
      case 1:
        result = 'missed check-in'
        break

      case 2:
        result = 'missed tracking'
        break

      case 3:
        result = 'missed check-in and tracking'
        break

      default:
        result = ''
    }

    return result
  }

  const renderSortArrows = (isSorting, reverse) => {
    return (
      <div style={{display: 'inline-block', marginLeft: '8px', marginTop: '5px', verticalAlign: 'top'}}>
        <ArrowsGroup>
          <ArrowUp fill={(isSorting && reverse) ? '#FFFFFF' : '#999999'} />
          <div style={{height: '3px'}}></div>
          <ArrowDown fill={(isSorting && !reverse) ? '#FFFFFF' : '#999999'}/>
        </ArrowsGroup>
      </div>
    )
  }

  const handleSort = (type) => {
    if (type !== sortType.type) {
      setSortType({type: type, reverse: false})
    } else {
      setSortType({type: type, reverse: !sortType.reverse})
    }
  }

  const compareEmail = (a, b) => {
    let result = 0
    const alc = a.email_address.toLowerCase()
    const blc = b.email_address.toLowerCase()

    if (alc < blc) {
      result = sortType.reverse ? 1 : -1
    } else if (alc > blc) {
      result = sortType.reverse ? -1 : 1
    }

    return result
  }

  const compareAlert = (a, b) => {
    let result = 0
    const isPaused = a.vacation_mode_info && !a.vacation_mode_info?.practice_mode
    const isPractice = a.vacation_mode_info && a.vacation_mode_info?.practice_mode
    const alc = a.user_id === null ? 'unclaimed' : (!a.trainer_permission ? 'no consent' : (isPaused ? 'goal paused' : isPractice ? 'practice mode' : renderAtRisk(a.at_risk)))
    const blc = b.user_id === null ? 'unclaimed' : (!b.trainer_permission ? 'no consent' : (isPaused ? 'goal paused' : isPractice ? 'practice mode' : renderAtRisk(b.at_risk)))

    if (alc < blc) {
      result = sortType.reverse ? 1 : -1
    } else if (alc > blc) {
      result = sortType.reverse ? -1 : 1
    }

    return result
  }

  const handleToggleAll = () => {
    const newAll = 1 - all
    updateAll(newAll)
    fetchWeeklySummaryData(newAll, interval)
  }

  const handleIntervalChange = (e) => {
    const newInterval = Number(e.target.value)
    updateInterval(newInterval)
    fetchWeeklySummaryData(all, newInterval)
  }

  const handleFilterGroupIDChange = (e) => {
    setFilterGroupID(Number(e.target.value))
  }

  const indices_by_goal = {'FAT LOSS': 2, 'MUSCLE GAIN': 3, 'REVERSE DIETING': 4, 'MAINTENANCE': 5}
  let ids_by_index = [[], [], [], [], [], [], [], [], [], [], [], [], []]
  let num_loss_eligible = 0
  let total_weight_lost = 0
  let net_weight_lost = 0
  let net_bf_lost = 0

  if (weeklySummaryDataState === 2) {
    weeklySummaryData.forEach((row) => {
      let qualifying
      if (filterGroupID === 0) {
        qualifying = true
      } else {
        qualifying = false
        for (let k = 0; k < user.accounts.length; ++k) {
          if (user.accounts[k].id === row.account_id) {
            if (user.accounts[k].groups.includes(filterGroupID)) {
              qualifying = true
            }
            break
          }
        }
      }
      if (qualifying) {
        ids_by_index[0].push(row.account_id)
        if (row.user_id !== null && row.trainer_permission) {
          ids_by_index[1].push(row.account_id)
          ids_by_index[indices_by_goal[row.goal]].push(row.account_id)
          if (row.vacation_mode_info && !row.vacation_mode_info?.practice_mode) {
            ids_by_index[6].push(row.account_id)
          } else if (row.vacation_mode_info && row.vacation_mode_info?.practice_mode) {
            ids_by_index[7].push(row.account_id)
          } else if (row.at_risk) {
            ids_by_index[8].push(row.account_id)
            if (row.at_risk === 1) {
              ids_by_index[9].push(row.account_id)
            } else if (row.at_risk === 2) {
              ids_by_index[10].push(row.account_id)
            } else {
              ids_by_index[11].push(row.account_id)
            }
          }
          if (row.this_date !== null) {
            ids_by_index[12].push(row.account_id)
            if (row.last_date !== null && row.goal === 'FAT LOSS') {
              ++num_loss_eligible
              if (row.last_weight > row.this_weight) {
                total_weight_lost += row.last_weight - row.this_weight
              }
              net_weight_lost += row.last_weight - row.this_weight
              net_bf_lost += row.last_body_fat - row.this_body_fat
            }
          }
        }
      }
    })
  }

  let sortedWeeklySummaryData = weeklySummaryData
  switch (sortType.type) {
    case 'email':
      sortedWeeklySummaryData = weeklySummaryData.slice(0).sort(compareEmail)
      break

    case 'name':
      if (sortType.reverse) {
        sortedWeeklySummaryData = weeklySummaryData.slice(0).reverse()
      }
      break

    case 'alert':
      sortedWeeklySummaryData = weeklySummaryData.slice(0).sort(compareAlert)
      break

    default:
  }

  let tableHeading = headings_by_index[selected]
  if (ids_by_index[selected].length === 1) {
    tableHeading = '1 ' + tableHeading.replace('Clients', 'Client')
  } else {
    tableHeading = ids_by_index[selected].length + ' ' + tableHeading
  }

  const handlePreview = () => {
    if (bulkMessage === '') {
      updateError('Please enter the message.')
    } else if (ids_by_index[selected].length === 0) {
      updateError('There are no ' + headings_by_index[selected] + '.')
    } else {
      setShowModal(true)
    }
  }

  const sendBulkMessage = async (selection, message) => {
    let result = { success: true, successful : 0, unclaimed: 0, failures: [] }
    for (let n = 0; n < weeklySummaryData.length; ++n) {
      if (selection.includes(weeklySummaryData[n].account_id)) {
        const clientID = weeklySummaryData[n].user_id
        if (clientID === null) {
          ++result.unclaimed
        } else {
          const getFilter = {
            type: 'portal',
            portal_owner: `${config.STREAMCHAT.portalUserPrefix}${user.owner_id}`,
            members: { $in: [`${config.STREAMCHAT.userPrefix}${clientID}`] },
            covered_user: `${config.STREAMCHAT.userPrefix}${clientID}`,
          }
          const sort = { last_message_at: -1 }
          const options = { watch: false, state: false }

          let channel = null
          const existingChannels = await client.queryChannels(getFilter, sort, options)
          if (existingChannels.length > 0) {
            channel = existingChannels[0]
          } else {
            const res = await getOrCreatePortalChannel(user.id, clientID)
            const channel_id = res.data.result.channel_id
            const newFilter = {
              id: channel_id
            }
            const newChannels = await client.queryChannels(newFilter, sort, options)
            if (newChannels.length > 0) {
              channel = newChannels[0]
            }
          }
          if (channel === null) {
            result.failures.push([weeklySummaryData[n].email_address, 'failed'])
          } else {
            const namedMessage = `Hey ${getFirstName(weeklySummaryData[n].name)}! ${bulkMessage}`
            await channel.sendMessage({text: namedMessage})
            ++result.successful
          }
        }
      }
    }
    return result
  }

  const handleBulkSend = () => {
    updateLoading(true)
    sendBulkMessage(ids_by_index[selected], bulkMessage).then((res) => {
      updateLoading(false)
      updateError('')
      if (!res.success) {
        updateResult(null)
        openSnackbar('There was a problem sending the bulk message.', true)
      } else if (res.successful === 0 && res.unclaimed === 0 && res.failures.length === 0) {
        updateResult(null)
        openSnackbar('There were no ' + headings_by_index[selected] + '.', true)
      } else {
        updateResult(Object.assign({}, res))
        openSnackbar('The bulk message completed.', false)
        setShowModal(false)
      }
    }).catch((err) => {
      console.log(err)
      updateLoading(false)
      updateError('')
      updateResult(null)
      openSnackbar('There was a problem sending the bulk message.', true)
    })
  }

  return (
    <GridContainer>
      {weeklySummaryDataState !== 2 ? (
        <CircularProgress size={32} />
      ) : (
        <>
          {(user.role_id === 1 || user.role_id === 2) &&
            <Toggle
              label="Show all clients (admin only)"
              checked={all === 1}
              onChange={handleToggleAll}
            />
          }
          <InputLabel id="interval-select-label" style={{color: '#676767', fontFamily: '"DM Sans", sans-serif', fontSize: '14px', fontWeight: '700', margin: '25px 0 5px 0'}}>Timeframe</InputLabel>
          <WeeklySelect value={interval} labelId="interval-select-label" label="Timeframe" disableUnderline onChange={handleIntervalChange}>
            <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={0}>Past Week</MenuItem>
            <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={1}>Past Month</MenuItem>
            <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={2}>Past Quarter</MenuItem>
          </WeeklySelect>
          <InputLabel id="filter-group-select-label" style={{color: '#676767', fontFamily: '"DM Sans", sans-serif', fontSize: '14px', fontWeight: '700', margin: '25px 0 5px 0'}}>Group Filter</InputLabel>
          <WeeklySelect value={filterGroupID} labelId="filter-group-select-label" label="Group Filter" disableUnderline onChange={handleFilterGroupIDChange}>
            <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} value={0}>(no filter)</MenuItem>
            {user.groups.map((entry, index) => (
              <MenuItem style={{color: '#5a5a5a', fontFamily: '"DM Sans", sans-serif', fontSize: '16px', fontWeight: '300'}} key={index} value={entry.id}>{entry.name}</MenuItem>
            ))}
          </WeeklySelect>
          <UpperWrapper>
            <SummaryContainer>
              <Label>
                <InfoOutlinedIcon /> Summary
              </Label>
              <SummaryTable>
                <tbody>
                  <tr style={selected === 0 ? active_row_style : inactive_row_style} onClick={() => updateSelected(0)}>
                    <th># covered clients</th>
                    <td>{ids_by_index[0].length}</td>
                  </tr>
                  <tr style={selected === 1 ? active_row_style : inactive_row_style} onClick={() => updateSelected(1)}>
                    <th># viewable clients</th>
                    <td>{ids_by_index[1].length}</td>
                  </tr>
                  {Object.keys(indices_by_goal).map((goal, index) => ids_by_index[indices_by_goal[goal]].length !== 0 && (
                    <tr key={index} style={selected === indices_by_goal[goal] ? active_row_style : inactive_row_style} onClick={() => updateSelected(indices_by_goal[goal])}>
                      <th># clients on {theme.goal[goal]}</th>
                      <td>{ids_by_index[indices_by_goal[goal]].length}</td>
                    </tr>
                  ))}
                  <tr style={selected === 6 ? active_row_style : inactive_row_style} onClick={() => updateSelected(6)}>
                    <th># clients in pause your goal mode</th>
                    <td>{ids_by_index[6].length}</td>
                  </tr>
                  <tr style={selected === 7 ? active_row_style : inactive_row_style} onClick={() => updateSelected(7)}>
                    <th># clients in practice mode</th>
                    <td>{ids_by_index[7].length}</td>
                  </tr>
                  <tr>
                    <th>- - -</th>
                    <td></td>
                  </tr>
                  <tr style={selected === 8 ? active_row_style : inactive_row_style} onClick={() => updateSelected(7)}>
                    <th># high risk clients</th>
                    <td>{ids_by_index[8].length}</td>
                  </tr>
                  <tr style={selected === 9 ? active_row_style : inactive_row_style} onClick={() => updateSelected(8)}>
                    <th># clients who missed check-in</th>
                    <td>{ids_by_index[9].length}</td>
                  </tr>
                  <tr style={selected === 10 ? active_row_style : inactive_row_style} onClick={() => updateSelected(9)}>
                    <th># clients who missed tracking</th>
                    <td>{ids_by_index[10].length}</td>
                  </tr>
                  <tr style={selected === 11 ? active_row_style : inactive_row_style} onClick={() => updateSelected(10)}>
                    <th># clients who missed both</th>
                    <td>{ids_by_index[11].length}</td>
                  </tr>
                  <tr>
                    <th>- - -</th>
                    <td></td>
                  </tr>
                  <tr style={selected === 12 ? active_row_style : inactive_row_style} onClick={() => updateSelected(11)}>
                    <th># clients who checked in</th>
                    <td>{ids_by_index[12].length}</td>
                  </tr>
                  {ids_by_index[1].length !== 0 && (
                    <tr>
                      <th>% clients who checked in</th>
                      <td>{(ids_by_index[12].length * 100 / ids_by_index[1].length).toFixed(0)}%</td>
                    </tr>
                  )}
                  <tr>
                    <th>total weight lost</th>
                    <td>{(total_weight_lost * 2.204622).toFixed(1)} lbs</td>
                  </tr>
                  <tr>
                    <th>net weight lost</th>
                    <td>{(net_weight_lost * 2.204622).toFixed(1)} lbs</td>
                  </tr>
                  {num_loss_eligible !== 0 && (
                    <tr>
                      <th>average weight lost</th>
                      <td>{(net_weight_lost * 2.204622 / num_loss_eligible).toFixed(1)} lbs</td>
                    </tr>
                  )}
                  <tr>
                    <th>net BF% lost</th>
                    <td>{net_bf_lost.toFixed(1)}%</td>
                  </tr>
                  {num_loss_eligible !== 0 && (
                    <tr>
                      <th>average BF% lost</th>
                      <td>{(net_bf_lost / num_loss_eligible).toFixed(1)}%</td>
                    </tr>
                  )}
                </tbody>
              </SummaryTable>
            </SummaryContainer>
            {!!user.messaging && (
              <BulkMessageContainer>
                <Label>
                  <ChatIcon /> Send a Bulk Message
                </Label>
                <Input
                  label="Message"
                  value={bulkMessage}
                  onChange={updateBulkMessage}
                />
                {error !== '' &&
                  <ErrorMessage>
                    {error}
                  </ErrorMessage>
                }
                <ButtonContainer>
                  <ClearButton
                    label="Clear"
                    onClick={() => { updateBulkMessage(''); updateError(''); updateResult(null); }}
                  />
                  <AddButton
                    label='Preview'
                    isLoading={loading}
                    onClick={handlePreview}
                  />
                </ButtonContainer>
                {result !== null && (
                  <div style={{marginTop: '10px'}}>
                    {result.successful !== 0 && (
                      <p>Number of successful messages: {result.successful}</p>
                    )}
                    {result.unclaimed !== 0 && (
                      <p>Number of unclaimed accounts: {result.unclaimed}</p>
                    )}
                    {result.failures.map((entry, index) => (
                      <p key={index}>{entry[0]}: {entry[1]}</p>
                    ))}
                  </div>
                )}
              </BulkMessageContainer>
            )}
          </UpperWrapper>
          <TableTitle>{tableHeading}</TableTitle>
          <TableContainer>
            <Table>
              <TableHead>
                <TableHeadRow>
                  <HeadCell  onClick={() => handleSort('email')} style={{cursor: 'pointer'}}>
                    Email
                    {renderSortArrows((sortType.type === 'email'), sortType.reverse)}
                  </HeadCell>
                  <HeadCell  onClick={() => handleSort('name')} style={{cursor: 'pointer'}}>
                    Name
                    {renderSortArrows((sortType.type === 'name'), sortType.reverse)}
                  </HeadCell>
                  <HeadCell  onClick={() => handleSort('alert')} style={{cursor: 'pointer'}}>
                    <DarkTooltip
                      enterDelay={500}
                      arrow
                      placement="top"
                      title={
                        <TipContent>
                          <p>This shows any factors that merit special attention for this client:</p>
                          <div style={{height: '8px'}}></div>
                          <li><span>unclaimed</span> = No user has registered with this email address</li>
                          <li><span>no consent</span> = This user has not given consent for the trainer to view their profile</li>
                          {/* <li><span>vacation</span> = This user has selected vacation mode</li> */}
                          <li><span>missed check-in</span> = This user has not checked in within the last 14 days</li>
                          <li><span>missed tracking</span> = This user has failed to log food on 3 or more days in the past week</li>
                          <li><span>missed check-in and tracking</span> = Both 'missed check-in' and 'missed tracking' apply</li>
                        </TipContent>
                      }
                    >
                      <span>Alert</span>
                    </DarkTooltip>
                    {renderSortArrows((sortType.type === 'alert'), sortType.reverse)}
                  </HeadCell>
                  <HeadCell>Previous<br/>Check-in<br/>Date</HeadCell>
                  <HeadCell>Previous<br/>Weight<br/>(lbs)</HeadCell>
                  <HeadCell>Previous<br/>BF%</HeadCell>
                  <HeadCell>Latest<br/>Check-in<br/>Date</HeadCell>
                  <HeadCell>Latest<br/>Weight<br/>(lbs)</HeadCell>
                  <HeadCell>Latest<br/>BF%</HeadCell>
                  <HeadCell>Weight<br/>Change<br/>(lbs)</HeadCell>
                  <HeadCell>BF%<br/>Change</HeadCell>
                  <HeadCell>Actions</HeadCell>
                </TableHeadRow>
              </TableHead>
              <TableBody>
                {sortedWeeklySummaryData.map((row, index) => {
                  if (!ids_by_index[selected].includes(row.account_id)) {
                    return null
                  }
                  const inspectable = row.user_id !== null && row.trainer_permission
                  let alert_text = ''
                  let prev_date = ''
                  let prev_weight = ''
                  let prev_bf = ''
                  let latest_date = ''
                  let latest_weight = ''
                  let latest_bf = ''
                  let weight_change = ''
                  let bf_change = ''

                  const lastIsPaused = !!(row?.last_vacation_mode_info && !row?.last_vacation_mode_info?.practice_mode)
                  const lastIsPractice = !!(row?.last_vacation_mode_info && row?.last_vacation_mode_info?.practice_mode)
                  const isPaused = !!(row?.vacation_mode_info && !row?.vacation_mode_info?.practice_mode)
                  const isPractice = !!(row?.vacation_mode_info && row?.vacation_mode_info?.practice_mode)

                  if (row.user_id === null) {
                    alert_text = 'unclaimed'
                  } else {
                    if (!row.trainer_permission) {
                      alert_text = 'no consent'
                    } else {
                      if (isPaused) {
                        alert_text = 'goal paused'
                      } else if (isPractice) {
                        alert_text = 'practice mode'
                      } else if (row.at_risk) {
                        alert_text = renderAtRisk(row.at_risk)
                      }
                      if (row.last_date !== null) {
                        prev_date = moment.utc(row.last_date).format('MMM D, YYYY')
                        prev_weight = (row.last_weight * 2.204622).toFixed(1)
                        prev_bf = row.last_body_fat.toFixed(1)
                      }
                      if (row.this_date !== null) {
                        latest_date = moment.utc(row.this_date).format('MMM D, YYYY')
                        latest_weight = (row.this_weight * 2.204622).toFixed(1)
                        latest_bf = row.this_body_fat.toFixed(1)
                      }
                      if (row.last_date !== null && row.this_date !== null) {
                        if (row.goal !== 'FAT LOSS') {
                          weight_change = 'N/A'
                          bf_change = 'N/A'
                        } else {
                          weight_change = ((row.this_weight - row.last_weight) * 2.204622).toFixed(1)
                          bf_change = (row.this_body_fat - row.last_body_fat).toFixed(1)
                        }
                      }
                    }
                  }
                  const clientIndex = _.findIndex(user.accounts, (client) => {
                    return client.id === row.account_id
                  })
                  const linkedPortalId = user.accounts[clientIndex].linked_portal_id
                  const linkedPortalName = user.accounts[clientIndex].linked_portal_name
                  return (
                    <TableBodyRow key={index}>
                      <DataCell>{row.email_address}</DataCell>
                      <DataCell>{row.name}</DataCell>
                      <DataCell>{alert_text}</DataCell>
                      <DataCell>
                        {(!!prev_date && lastIsPaused) && <VacationText color="#32F6DB">PAUSED</VacationText>}
                        {(!!prev_date && lastIsPractice) && <VacationText color="#CFE92A">PRACTICE</VacationText>}
                        {prev_date}
                      </DataCell>
                      <DataCell>{prev_weight}</DataCell>
                      <DataCell>{prev_bf}</DataCell>
                      <DataCell>
                        {(!!latest_date && isPaused) && <VacationText color="#32F6DB">PAUSED</VacationText>}
                        {(!!latest_date && isPractice) && <VacationText color="#CFE92A">PRACTICE</VacationText>}
                        {latest_date}
                      </DataCell>
                      <DataCell>{latest_weight}</DataCell>
                      <DataCell>{latest_bf}</DataCell>
                      <DataCell>{weight_change}</DataCell>
                      <DataCell>{bf_change}</DataCell>
                      <DataCell>
                        {!!inspectable && (
                          <Row>
                            <Action
                              icon={<SearchIcon />}
                              text="Inspect"
                              onClick={() => { props.history.push('/dashboard/inspect/' + row.account_id + '/overview') }}
                            />
                            {!!user.messaging ?
                              (createdStreamUsers.includes(config.STREAMCHAT.userPrefix + row.user_id.toString()) && !linkedPortalId) ?
                                <Action
                                  hideOnClick
                                  icon={<Icon>message</Icon>}
                                  text="Chat"
                                  onClick={() => handleMessage(row.user_id)}
                                />
                              :
                                <Action
                                  disabled
                                  tipText={linkedPortalId ? `This user is a coach account for ${linkedPortalName}.` : "This user must sign in before messaging is available."}
                                  icon={<Icon>message</Icon>}
                                  text="Chat"
                                  onClick={() => null}
                                />
                              :
                              null
                            }
                          </Row>
                        )}
                      </DataCell>
                    </TableBodyRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Modal
            title="Confirm Bulk Message"
            message={"Hey {client's name}! " + bulkMessage}
            submitLabel={'Send Bulk Message to ' + tableHeading}
            open={showModal}
            onClose={() => setShowModal(false)}
            handleSubmit={handleBulkSend}
          />
        </>
      )}
    </GridContainer>
  )
}

export default withRouter(Weekly)